import React from "react"
import {connect} from "react-redux"
import {GlobalState} from "../../state"
import {FontAwesomeIcon as Icon} from "@fortawesome/react-fontawesome"
import {faList, faTh} from "@fortawesome/free-solid-svg-icons"
import {updateUser} from "../../redux/actions"
import {User} from "../../domain-models"
import {store} from "../../store"
import {Http} from "../../mixins/http"
import Form from "../../mixins/form"
import {FormType} from "../../mixins/FormTypes"

type SwitchAuctionViewProps = {
  view: 'grid' | 'list'
  user: User
}

type SwitchAuctionViewState = {
  form: FormType
}

class SwitchAuctionView extends React.Component<SwitchAuctionViewProps, SwitchAuctionViewState> {
  setListView = async (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()

    if (!this.props.user.app_settings) {
      this.props.user.app_settings = {
        auction_view: 'grid',
        budget: 0
      }
    }

    if (this.props.view !== 'list') {
      this.props.user.app_settings.auction_view = 'list'
      store.dispatch(updateUser(this.props.user))

      await Http.put('/app-settings', {state: this, form: new Form({auction_view: 'list'})})
    }
  }

  setGridView = async (event: React.MouseEvent) => {
    event.stopPropagation()
    event.preventDefault()

    if (!this.props.user.app_settings) {
      this.props.user.app_settings = {
        auction_view: 'grid',
        budget: 0
      }
    }

    if (this.props.view !== 'grid') {
      this.props.user.app_settings.auction_view = 'grid'
      store.dispatch(updateUser(this.props.user))

      await Http.put('/app-settings', {state: this, form: new Form(({auction_view: 'grid'}))})
    }
  }
  render() {
   return (
     <div className={'flex flex-row'}>
       <button className={'mx-1' + (this.props.view === 'grid' ? ' text-blue-500 ' : ' text-gray-600')} onClick={this.setGridView}><Icon icon={faTh} /></button>
       <button className={'mx-1' + (this.props.view === 'list' ? ' text-blue-500 ' : ' text-gray-600')} onClick={this.setListView}><Icon icon={faList} /></button>
     </div>
   )
  }
}

export default connect((state: GlobalState) => ({
  view: state.user.app_settings ? state.user.app_settings.auction_view : 'grid',
  user: state.user
}))(SwitchAuctionView)
